import { FC } from 'react';
import { useRegisteredRef } from '../utils/formHelpers';

interface IRegisterElementProps {
  name: string;
  children: (ref: any) => JSX.Element;
}
type RegisterElement = FC<IRegisterElementProps>;

export const RegisterElement: RegisterElement = ({ name, children }) => {
  const ref = useRegisteredRef(name);

  return children(ref);
};
